module.exports = __webpack_public_path__ + "img/10.f32d2da3.png";